import { isTerminal } from '../taskModel';
import { useTasksJobs } from './useTasksJobs';
export function useHasUnseenNotifications() {
    const { tasks } = useTasksJobs();
    return tasks.some((t)=>isTerminal(t.status) && !t.seen);
}
